import React from 'react'

interface PreloadableComponent<
  TProps extends {} = {},
  TComp extends React.ComponentType<TProps> = React.ComponentType<TProps>
> extends React.LazyExoticComponent<TComp> {
  preload: () => Promise<{
    default: React.ComponentType<TProps>
  }>
}

function lazyWithPreload<
  TProps extends {} = {},
  TComp extends React.ComponentType<TProps> = React.ComponentType<TProps>
>(
  factory: () => Promise<{ default: TComp }>
): PreloadableComponent<TProps, TComp> {
  return Object.assign(React.lazy<TComp>(factory), {
    preload: factory,
  })
}

export default lazyWithPreload
